<template>
  <div id="reports">
    <h5 class="pf-sub-head mb-3">Search families</h5>
    <v-layout wrap row class="mb-1">
      <v-flex sm4 class="pr-2">
        <v-autocomplete
            v-model="report.agency" 
            @keyup.enter="searchAgencies($event)"
            :items="searchedAgencies" 
            item-text="name"
            @change="applyFliters"
            item-value="id"
            label="Search by Agency"
            id="agencySearch"
            hide-no-data
            clearable
            hint="Type atleast 3 characters to search"
            class="pr-4">
            <v-icon slot="append" @click="searchAgencies($event)"> search </v-icon>
          </v-autocomplete>
      </v-flex>
      <v-flex sm4 class="pr-2">
        <v-select v-model="report.membership" label="Membership type" :items="[...['All'], ...membershipTypes]" @change="applyFliters"></v-select>
      </v-flex>
      <v-flex sm4 class="pr-2">
        <v-daterange
          ref="dateRange" 
          v-model="dateRange" 
          :presets="presets" 
          display-format="MM/dd/yyyy"
          :max="new Date().toISOString().substr(0,10)" 
          :input-props="inputProps"
          :show-reset="false"
          @menu-closed="applyFliters"
          class="dateRange">
        </v-daterange>
      </v-flex>
    </v-layout>
    <v-layout class="mb-3">
      <v-btn class="pf-btn pf-bg-teal">
        <download-excel :data="familyList" :fields="exportFields" :name="exportExcelName">Export to Excel</download-excel>
      </v-btn>
    </v-layout>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="familyList"
        :search="search"
        no-data-text="No results, Search for your families"
        :pagination.sync="pagination" 
        class="pf-data-table"
      >
        <template v-slot:items="props">
          <tr :class="{ 'pf-row-highlighted': props.item.agency && props.item.agency.length > 1 }">
            <td>{{ props.item.human.length ? (props.item.human[0].first_name + ' ' + props.item.human[0].last_name) : '--' }}</td>
            <td>{{ props.item.account_type === 'Couple' && props.item.human.length > 1 ? (props.item.human[1].first_name + ' ' + props.item.human[1].last_name) : '--' }}</td>
            <td>{{ props.item.membership }}</td>
            <td>{{ props.item.account_type }}</td>
            <td>{{ getAgency(props.item) }}</td>
            <td>{{ props.item.nickname }}</td>
            <td>{{ props.item.contactInfo ? props.item.contactInfo.email : '--' }}</td>
            <td>
              {{ formatDate(props.item.createdAt) }}
            </td>
            <td>
              {{ props.item.ppn }}
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<script>
/* global session config */
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import { getCollection, formatDate } from '../../helpers/helpers';
import { VDaterange } from 'vuetify-daterange-picker';
import JsonExcel from 'vue-json-excel';
import 'vuetify-daterange-picker/dist/vuetify-daterange-picker.css';
import moment from 'moment';
moment.tz.setDefault(config.timezone);
export default {
  name: 'Reports',
  components: {
    VuePerfectScrollbar,
    VDaterange,
    'downloadExcel': JsonExcel
  },
  data: () => ({
    report: {
      agency: '',
      membership: 'All'
    },
    config: config,
    searchedAgencies: [],
    membershipTypes: ['Network', 'Featured', 'Preferred'],
    familyList: [],
    search: '',
    dateRange: { 
      start: moment().startOf('month').format('YYYY-MM-DD'),
      end: moment().format('YYYY-MM-DD')
    },
    presets: [
      // {
      //   label: 'All',
      //   range: [
      //     moment().startOf('day').format('YYYY-MM-DD'),
      //     moment().endOf('day').format('YYYY-MM-DD'),
      //   ],
      // },
      {
        label: 'Today',
        range: [
          moment().startOf('day').format('YYYY-MM-DD'),
          moment().endOf('day').format('YYYY-MM-DD'),
        ],
      },
      {
        label: 'Yesterday',
        range: [
          moment().add(-1, 'days').format('YYYY-MM-DD'),
          moment().add(-1, 'days').endOf('day').format('YYYY-MM-DD')
        ]
      },
      {
        label: 'This Week',
        range: [
          moment().startOf('week').format('YYYY-MM-DD'),
          moment().endOf('week').format('YYYY-MM-DD')
        ]
      },
      {
        label: 'Last 7 days',
        range: [
          moment().add(-7, 'days').format('YYYY-MM-DD'),
          new Date().toISOString().substr(0, 10)
        ]
      },
      {
        label: 'Last 15 days',
        range: [
          moment().add(-15, 'days').format('YYYY-MM-DD'),
          new Date().toISOString().substr(0, 10)
        ]
      },
      {
        label: 'This Month',
        range: [
          moment().startOf('month').format('YYYY-MM-DD'),
          new Date().toISOString().substr(0, 10)
        ]
      },
      {
        label: 'Last Month',
        range: [
          moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'),
          moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD')
        ]
      },
      {
        label: 'Last 3 Month',
        range: [
          moment().subtract(3, 'month').startOf('month').format('YYYY-MM-DD'),
          moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD')
        ]
      },
    ],
    inputProps: {
      'prepend-icon': 'event',
      'label': 'Date Range'
    },
    headers: [
      { text: 'Parent 1', value: '', align: 'left' },
      { text: 'Parent 2', value: '', align: 'left' },
      { text: 'Membership', value: 'membership', align: 'left' },
      { text: 'Account', value: 'account_type', align: 'left' },
      { text: 'Agency', value: 'default_agency.name', align: 'left' },
      { text: 'Username', value: 'nickname', align: 'left' },
      { text: 'Email', value: 'contactInfo.email', align: 'left' },
      { text: 'Join Date', value: 'createdAt', align: 'left', width: '160px' },
      { text: 'PPN', value: 'ppn' },
    ],
    pagination: {
      rowsPerPage: config.dom.rowsPerPage,
      sortBy: ''
    },
    exportFields: {
      'Parent 1 Name': {
        callback: (value) => {
          return value.human.length ? (value.human[0].first_name + ' ' + value.human[0].last_name) : '--';
        }
      },
      'Parent 2 Name': {
        callback: (value) => {
          return value.account_type === 'Couple' && value.human.length > 1 ? (value.human[1].first_name + ' ' + value.human[1].last_name) : '--';
        }
      },
      'Membership Type': 'membership',
      'Account Type': 'account_type',
      'Agency': {
        callback: (value) => {
          if (value.default_agency && value.default_agency.name) {
            return value.default_agency.name;
          } else if (value.agency && value.agency.length && value.agency[0].agency) {
            return value.agency[0].agency.name || '--';
          } else {
            return '--';
          }
        }
      },
      'Username': 'nickname',
      'Email Address': {
        field: 'contactInfo',
        callback: (value) => {
          return value && value.email ? value.email : '--';
        }
      },
      'Join Date': {
        field: 'createdAt',
        callback: (value) => {
          return formatDate(value, 'MM/DD/YYYY');
        }
      },
      'PPN': 'ppn'
    },
    json_meta: [
      [
        {
          'key': 'charset',
          'value': 'utf-8'
        }
      ]
    ]
  }),
  computed: {
    exportExcelName () {
      return 'PF_Fmilies_' + (this.report.agency ? this.searchedAgencies[this.searchedAgencies.findIndex(x => x.id === this.report.agency)].name.split(' ').join('-') + '_' : '') + (this.report.membership && this.report.membership !== 'All' ? this.report.membership + '_' : '') + (formatDate(new Date(this.dateRange.start), 'MM-DD-YYYY') + '-to-' + formatDate(new Date(this.dateRange.end), 'MM-DD-YYYY') + '_') + moment().tz(config.timezone).format('MMDDYYYY');
    }
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline())
    {
      // return;
      next({ path: '/login' });
    }
    else
    {
      next();
    }
  },
  watch: {

  },
  created () {
    this.applyFliters();
  },
  methods: {
    async searchAgencies (e) {
      this.searchedAgencies = [];
      this.unselectedAgnecies = [];
      this.searchAgencyString = e.target.value ? e.target.value : document.querySelector('input[id="agencySearch"]').value;
      if ((this.searchAgencyString.length > 2)) {
        let where = { is_admin: false };
        if (!where.$or) {
          where.$or = [{
            'name': { $regex: `.*` + this.searchAgencyString + `.*`, $options: 'i' }
          }];
        } else {
          where.$or.push({
            'name': { $regex: `.*` + this.searchAgencyString + `.*`, $options: 'i' }
          });
        }       
        let attributes = 'name';
        let { error, data } = await getCollection('Agency', true, 0, '', where, attributes);
        if (error) {
          console.log(error);
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Failed to load agency list'
          };
        } else {
          if (data.length > 0) {
            this.searchedAgencies = data;
          } else {
            this.searchedAgencies = [];
          }
        }
      }
    },
    async applyFliters () {
      this.familyList = [];
      let maxEndDate = (new Date(this.dateRange.end)).setDate((new Date(this.dateRange.end)).getDate() + 1);
      let where = {
        'agency.status': { '$nin': ['Rejected'] },
        'createdAt': { '$gte': this.dateRange.start, '$lt': maxEndDate }
      };

      if (this.report.agency && this.report.agency !== '') {
        where['agency.agency'] = this.report.agency;
      }
      if (this.report.membership && this.report.membership !== 'All') {
        where['membership'] = this.report.membership;
      }
      
      let populate = [{ 'path': 'human', 'select': 'first_name last_name' }, { 'path': 'default_agency', 'select': 'name' }, { 'path': 'agency.agency', 'select': 'name' }];
      let sort = { 'createdAt': -1 };
      let attributes = 'membership,account_type,default_agency,agency,nickname,contactInfo.email,profile_year,profile_number,createdAt';
      let { error, data } = await getCollection('Account', true, 0, populate, where, attributes, null, sort);
      if (error) {
        console.log(error);
        this.snackbar = {
          show: true,
          color: 'red',
          text: 'Failed to load family list'
        };
      } else {
        if (data.length > 0) {
          this.familyList = data;
        }
      }
    },
    getAgency (item) {
      if (item.default_agency && item.default_agency.name) {
        return item.default_agency.name;
      } else if (item.agency && item.agency.length && item.agency[0].agency) {
        return item.agency[0].agency.name || '--';
      } else {
        return '--';
      }
    },
    formatDate (dateString) {
      if (dateString) {
        return formatDate(dateString, 'MM/DD/YYYY');
      }
    }
  }
};
</script>
<style scoped lang="css">
  .dateRange >>> .v-menu {
    width: 100% !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Reports/Reports.vue